<ciao-modal #viewAndEditModal title="{{ modalTitle$ | async }}">
  <div modalBody>
    <span *ngIf="selectedTeamPermissions$ | async as teamPermissions">
      <ciao-user-group-form
        #actionUserGroupForm
        [userGroupId]="activeUserGroupId"
        [isEditForm]="isEditForm"
        [canEditUserGroup]="teamPermissions?.edit || !isEditForm"
        [canEditParentGroup]="(canCreateTeam$ | async) || !isEditForm"
        [canEditTeamMembers]="teamPermissions?.assignTeamMember || !isEditForm"
        [canEditSupervisors]="teamPermissions?.assignSupervisor || !isEditForm"
        [canEditDispatchers]="teamPermissions?.assignDispatcher || !isEditForm"
        [canEditGuests]="teamPermissions?.assignGuest || !isEditForm"
        [canViewTeamMembers]="teamPermissions?.viewTeamMembers || !isEditForm"
      ></ciao-user-group-form>
    </span>
  </div>

  <span modalFooter>
    <!--
      v2.4 footer: Delete Team is left-aligned (only rendered for users with
      delete permission), Cancel + Update grouped on the right. Note the gating
      on Delete still uses `delete_usergroup` (admin-only per seed), which is
      stricter than the Figma spec's "Supervisors/Admins" label — flagged for
      design alignment in Phase 6.
    -->
    <div class="team-modal-footer">
      <div class="team-modal-footer__left">
        <button
          *ngIf="(selectedTeamPermissions$ | async)?.remove"
          class="btn-action-light center"
          (click)="deleteUserGroupModal.openModal()"
        >
          Delete Team
        </button>
      </div>
      <div class="team-modal-footer__right">
        <button
          class="btn-action-light center"
          (click)="viewAndEditModal.dismiss('cancel')"
        >
          Cancel
        </button>
        <button
          *ngIf="isEditForm == false; else editSaveButton"
          class="btn-action-solid center"
          (click)="saveData()"
          [disabled]="!actionUserGroupForm?.allowSave"
        >
          Confirm
        </button>
        <ng-template #editSaveButton>
          <button
            *ngIf="(selectedTeamPermissions$ | async)?.clickUpdate"
            class="btn-action-solid center"
            (click)="saveData()"
            [disabled]="!actionUserGroupForm?.allowSave"
          >
            Update
          </button>
        </ng-template>
      </div>
    </div>
  </span>
</ciao-modal>

<ciao-modal #deleteUserGroupModal title="Confirm Team Deletion">
  <div modalBody>
    <h2>
      Are you sure you want to delete <br />
      {{ userGroup?.parent?.label }} - {{ userGroup?.label }}?
    </h2>
  </div>
  <span modalFooter>
    <div class="d-flex">
      <button
        class="btn-action-light center"
        (click)="deleteUserGroupModal.dismiss('cancel')"
      >
        Cancel
      </button>
      <button class="btn-action-solid center" (click)="deleteData()">
        Confirm Delete
      </button>
    </div>
  </span>
</ciao-modal>
